<template>
  <div :class="{ 'report-wish-page': true }">
    <PageSkeleton
      :animate="active"
      :show-footer="false"
    >
      <ReportLeader
        text="班主任寄语"
        center
        :active="active"
      />
      <div class="report-text slide-in slide-in-1">
        你有备而来
      </div>
      <div class="report-text slide-in slide-in-2">
        定凯旋而归
      </div>
      <div class="report-text" />
      <div class="report-text slide-in slide-in-3">
        相信光·追逐光·成为光
      </div>
      <div class="report-text slide-in slide-in-4">
        愿你们得偿所愿
      </div>
      <div class="report-text slide-in slide-in-5">
        高分上岸
      </div>
      <div class="report-text" />
      <div class="report-text slide-in slide-in-6">
        谢谢你的支持和认可
      </div>
      <div class="report-text slide-in slide-in-7">
        2024
      </div>
      <div class="report-text slide-in slide-in-8">
        我们继续并肩前行
      </div>
      <div
        :class="{ 'btn-replay': true, active: active }"
        @click="replayReport"
      >
        重新回顾
      </div>
    </PageSkeleton>
  </div>
</template>
<script setup>
import PageSkeleton from "./PageSkeleton.vue";
import ReportLeader from "./ReportLeader.vue";
defineProps({
  active: {
    type: Boolean,
    default: false
  }
});
const wishEmits = defineEmits(["replay"])
const replayReport = () => {
  wishEmits("replay");
}
</script>
<style lang="scss" scoped>
.report-wish-page {
  background: url("~@/assets/student/studyReport/postgraduate/2023/bg-wish.png");
  background-size: 100%;
  text-align: center;

  .btn-replay {
    width: 300px;
    height: 80px;
    border: 2px solid #333333;
    line-height: 80px;
    font-size: 34px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin: 120px auto 0 auto;
    opacity: 0;
    transform: translateY(40px);
    &.active {
      transition-property: opacity,transform;
      transition-duration: 1.1s;
      transition-timing-function: ease-in;
      transition-delay: 6s;
      transform: translateY(0);
      opacity: 1;
    }
  }
  @media screen and (min-height: 750px) {
    .btn-replay {
      margin-top: 200px;
    }
  }
}
</style>